import { useApp } from "../context/AppContext";

export default function ToggleSwitch() {
  const { dark, setDark } = useApp();
  return (
    <div onClick={() => { setDark(d => { localStorage.setItem("metago_dark", String(!d)); return !d; }); }} style={{
      width: 52, height: 28, borderRadius: 14, padding: 2, cursor: "pointer",
      background: dark ? "#6366f1" : "#e0e0e0", transition: "background .3s",
      display: "flex", alignItems: "center", position: "relative", flexShrink: 0
    }}>
      <div style={{
        width: 24, height: 24, borderRadius: 12, background: "#fff",
        transform: dark ? "translateX(24px)" : "translateX(0)",
        transition: "transform .3s", display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: "0 1px 3px rgba(0,0,0,.2)", fontSize: 14
      }}>
        {dark ? "🌙" : "☀️"}
      </div>
    </div>
  );
}
